import Button from 'app/components/Button'
import React from 'react'

interface FilterDropdownProps {
  isOpen: boolean
  activeFilterCount: number
  toggleDropdown2: () => void
  selectedFramework: string
  setSelectedFramework: (framework: string) => void
  selectedStatus: string
  setSelectedStatus: (status: string) => void
  selectedOwner: string
  setSelectedOwner: (owner: string) => void
  personnels: any[]
  selectedAuthor: string
  setSelectedAuthor: (author: string) => void
  handleResetClick: () => void
  filterData: () => void
  dropdownRef: React.RefObject<HTMLDivElement>
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  isOpen,
  activeFilterCount,
  toggleDropdown2,
  selectedFramework,
  setSelectedFramework,
  selectedStatus,
  setSelectedStatus,
  selectedOwner,
  setSelectedOwner,
  personnels,
  selectedAuthor,
  setSelectedAuthor,
  handleResetClick,
  filterData,
  dropdownRef,
}) => {

  return (
    <div className='position-relative' ref={dropdownRef}>
      <Button
        className='me-4'
        onClick={toggleDropdown2}
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='18'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='icon icon-tabler icons-tabler-outline icon-tabler-filter me-2 mb-1'
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z' />
        </svg>
        Filter
        {activeFilterCount > 0 && (
          <span
            className='badge badge-circle ms-2'
            style={{
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              backgroundColor: '#E1E1E1',
            }}
          >
            {activeFilterCount}
          </span>
        )}
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={`icon icon-tabler icons-tabler-outline icon-tabler-chevron-down ms-2 ${
            isOpen ? 'rotate-180' : ''
          }`}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M6 9l6 6l6 -6' />
        </svg>
      </Button>

      {isOpen && (
        <div
          className='menu menu-sub menu-sub-dropdown w-300px w-md-325px'
          data-kt-menu='true'
          style={{
            position: 'absolute',
            top: '110%',
            right: 0,
            zIndex: 1000,
            display: 'block',
            backgroundColor: '#fff',
            borderRadius: '0.475rem',
            boxShadow: '0 0 50px 0 rgba(82,63,105,.15)',
            border: '1px solid #ebedf3',
          }}
        >
          <div className='px-5 py-6'>
            <div className='fs-5 text-dark fw-bold'>Filter Options</div>
          </div>
          <div className='separator border-gray-200'></div>
          <div className='px-5 pt-5 pb-2' data-kt-user-table-filter='form'>
            {/* Framework filter */}
            <div className='mb-3'>
              <label className='form-label fs-6'>Framework:</label>
              <div className='mb-3 d-flex align-items-center'>
                <select
                  id='framework'
                  className='form-select form-control'
                  aria-label='Select Framework'
                  value={selectedFramework}
                  onChange={(e) => setSelectedFramework(e.target.value)}
                >
                  <option value='' disabled selected>
                    Select Framework
                  </option>
                  <option value='ISO 27001:2022'>ISO 27001</option>
                  <option value='SOC'>SOC 2</option>
                  <option value='GDPR'>GDPR</option>
                  <option value='HIPAA'>HIPAA</option>
                </select>
                {selectedFramework && (
                  <button
                    className='btn btn-link p-0'
                    onClick={(e) => {
                      setSelectedFramework('')
                      e.stopPropagation()
                    }}
                  >
                    <span aria-hidden='true' className='mx-2 fw-bold fs-2'>
                      &times;
                    </span>
                  </button>
                )}
              </div>
            </div>

            {/* Status filter */}
            <div className='mb-3'>
              <label className='form-label fs-6'>Status</label>
              <div className='mb-3 d-flex align-items-center'>
                <select
                  id='status'
                  className='form-select form-control'
                  aria-label='Select Status'
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value='' disabled selected>
                    Select Status
                  </option>
                  <option value='OK'>OK</option>
                  <option value='Unhealthy'>Unhealthy</option>
                  <option value='Deactivated'>Deactivated</option>
                </select>
                {selectedStatus && (
                  <button
                    className='btn btn-link p-0'
                    onClick={(e) => {
                      setSelectedStatus('')
                      e.stopPropagation()
                    }}
                  >
                    <span aria-hidden='true' className='mx-2 fw-bold fs-2'>
                      &times;
                    </span>
                  </button>
                )}
              </div>
            </div>

            {/* Owner filter */}
            <div className='mb-3'>
              <label htmlFor='owner' className='form-label fs-6'>
                Owner
              </label>
              <div className='mb-3 d-flex align-items-center'>
                <select
                  id='owner'
                  className='form-select form-control'
                  aria-label='Select Owner'
                  value={selectedOwner}
                  onChange={(e) => setSelectedOwner(e.target.value)}
                >
                  <option value='' disabled selected>
                    Select Owner
                  </option>
                  {personnels
                    .filter((data) => data.role === 'Admin' || data.role === 'Owner')
                    .map((personnel) => (
                      <option key={personnel.id} value={personnel.full_name}>
                        {personnel.full_name}
                      </option>
                    ))}
                </select>
                {selectedOwner && (
                  <button
                    className='btn btn-link p-0'
                    onClick={(e) => {
                      setSelectedOwner('')
                      e.stopPropagation()
                    }}
                  >
                    <span aria-hidden='true' className='mx-2 fw-bold fs-2'>
                      &times;
                    </span>
                  </button>
                )}
              </div>
            </div>

            {/* Author filter */}
            <div className='mb-3'>
              <label htmlFor='author' className='form-label fs-6'>
                Author
              </label>
              <div className='mb-3 d-flex align-items-center'>
                <select
                  id='author'
                  className='form-select form-control'
                  aria-label='Select Author'
                  value={selectedAuthor}
                  onChange={(e) => setSelectedAuthor(e.target.value)}
                >
                  <option value='' disabled selected>
                    Select author
                  </option>
                  <option value='SecureSlate'>SecureSlate</option>
                  <option value='Custom Control'>Custom Control</option>
                </select>
                {selectedAuthor && (
                  <button
                    className='btn btn-link p-0'
                    onClick={(e) => {
                      setSelectedAuthor('')
                      e.stopPropagation()
                    }}
                  >
                    <span aria-hidden='true' className='mx-2 fw-bold fs-2'>
                      &times;
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className='separator border-gray-200 '></div>
          <div className='d-flex justify-content-end my-5 px-4'>
            <Button
              onClick={(e) => {
                handleResetClick()
                e.stopPropagation()
              }}
              className='btn btn-sm btn-light fw-bold  px-6 fs-6 w-100'
            >
              Reset
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
